import { render } from "./PurchaseReturnReport.vue?vue&type=template&id=7e021846&scoped=true"
import script from "./PurchaseReturnReport.vue?vue&type=script&lang=js"
export * from "./PurchaseReturnReport.vue?vue&type=script&lang=js"

import "../inventory/inventoryReport.css?vue&type=style&index=0&id=7e021846&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e021846"]])

export default __exports__